<template>
  <div class="title">
    <span>View Project Details</span>
    <span class="SproutIcon SproutIcon-cross-regular" @click="closeViewing"></span>
  </div>
</template>
<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: $neutral-800;
  border-bottom: 1px solid $neutral-40;
  .SproutIcon-cross-regular {
    color: $neutral-400;
    cursor: pointer;
  }
  .SproutIcon-cross-regular:hover {
    color: $green-300;
  }
}
</style>
<script>
import { storeToRefs } from 'pinia';
import { useProjectTaggingStore } from '../../../../stores/projectTagging';

export default {
  name: 'ProjectTaggingViewProjectTitle',
  setup() {
    const projectTaggingStore = useProjectTaggingStore();
    const { viewProject, selectedProject } = storeToRefs(projectTaggingStore);
    const closeViewing = () => {
      selectedProject.value = null;
      viewProject.value = false;
    };

    return {
      closeViewing,
    };
  },
};
</script>
